export const getTVaultArrData = ({ threatvault }) => threatvault.threatArrData;
export const getTVaultArrDataSha = ({ threatvault }) => threatvault.threatArrDataSha;
export const getTVaultIdData = ({ threatvault }) => threatvault.threatIdData;
export const getRemainPerDay = ({ threatvault }) => threatvault.perDay;
export const getRemainPerMinute = ({ threatvault }) => threatvault.perMinute;
export const getTvaultErrors = ({ threatvault }) => threatvault.errors;
export const getTvaultLoader = ({ threatvault }) => threatvault.loaders.common;